import glamorous from 'glamorous';

const Main = glamorous.main({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 2,
});

export default Main;



// WEBPACK FOOTER //
// ./src/components/layout/Main.js